import React, { useEffect, useState } from 'react';
import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';
import styled from 'styled-components';
import { Container } from 'lmc-ui-library';
import { NavLink, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import { Loader } from 'components/Loader/Loader';
import DueDiligenceContainer from 'screens/Panel/screens/Club/containers/DueDiligenceContainer';
import ClubProfileContainer from 'screens/Panel/screens/Club/containers/ClubProfileContainer';
import loadClub from 'screens/Panel/screens/Club/store/show/useCases/loadClub';
import HeaderContainer from 'screens/Panel/screens/Club/containers/HeaderContainer';
import ErrorModal from 'screens/Panel/components/ErrorModal/ErrorModal';
import { Nullable } from 'utils/types';
import { Tabs } from 'screens/Panel/components';

const Wrapper = styled.div`
  margin-top: 50px;
`;

const TabsWrapper = styled.div`
  margin: 30px 0;
  background: white;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
`;

const Show: React.FC<any> & PageLayoutParams = () => {
  const [modalError, setModalError] = useState<Nullable<Error>>(null);
  let { path, url, params } = useRouteMatch<{ id: string }>();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.clubShow.isLoading);
  const club = useSelector((state: RootState) => state.clubShow.club);

  useEffect(() => {
    (async () => {
      try {
        await dispatch(loadClub(params.id));
      } catch (error) {
        setModalError(error);
      }
    })();
  }, [dispatch, params.id]);

  return (
    <>
      {isLoading && (
        <div style={{ position: 'relative' }}>
          <Loader />
        </div>
      )}
      {!isLoading && club !== undefined && (
        <Wrapper>
          <Container>
            <HeaderContainer />
          </Container>
          <TabsWrapper>
            <Container>
              <Tabs.Wrapper>
                <Tabs.Item>
                  <NavLink to={url} exact={true}>
                    Club details
                  </NavLink>
                </Tabs.Item>
                <Tabs.Item>
                  <NavLink to={`${url}/due-diligence`}>Due diligence</NavLink>
                </Tabs.Item>
              </Tabs.Wrapper>
            </Container>
          </TabsWrapper>
          <Container>
            <div style={{ position: 'relative' }}>
              <Switch>
                <Route exact path={path}>
                  <ClubProfileContainer />
                </Route>
                <Route path={`${path}/due-diligence`}>
                  <DueDiligenceContainer />
                </Route>
              </Switch>
            </div>
          </Container>
        </Wrapper>
      )}
      <ErrorModal show={modalError !== null} error={modalError} onClose={() => setModalError(null)} />
    </>
  );
};

Show.layout = Layouts.PANEL_WITHOUT_CONTAINER;

export default Show;
